/* src/app/views/template/components/edit-template-menu/edit-template-marketing-menu/edit-template-marketing-featured-product-menu/edit-template-marketing-featured-product-menu.component.scss */
/*# sourceMappingURL=edit-template-marketing-featured-product-menu.component.css.map */
